/***
 * Regex function that checks if the browser is in app  and we can decide
 * if we need to render or not some GalaBid features
 *
 * ie: google social login does not work as well as google address autocomplete, so
 * we hide them with this function
 */
export function isInApp(): boolean {
  const userAgent = window.navigator.userAgent
  const rules = ['WebView', '(iPhone|iPod|iPad)(?!.*Safari/)', 'Android.*(wv)']
  const regex = new RegExp(`(${rules.join('|')})`, 'ig')
  return Boolean(userAgent.match(regex))
}
